import { Injectable } from '@angular/core';
import { EventManager } from 'app/shared/services';
import { HttpInterceptor, HttpRequest, HttpErrorResponse, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

const UNAUTHORIZED = 401;

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
    constructor(private eventManager: EventManager) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap(
                (event: HttpEvent<any>) => {},
                (err: any) => {
                    if (err instanceof HttpErrorResponse) {
                        if (err.status !== UNAUTHORIZED) {
                            this.eventManager.broadcast({ name: 'fdeGatewayApp.httpError', content: err });
                        }
                    }
                }
            )
        );
    }
}
